
import CommonPopup from "@/components/CommonPopup.vue";
import { RelUgcProductVO } from "@/views/biz/ugc/vo/ugc.vo";
import axios from "axios";
import { Component, Prop, Watch } from "vue-property-decorator";

@Component
export default class ReviewProductSearchPop extends CommonPopup {
  @Prop() product!: RelUgcProductVO;

  inputKeyword = ""; // 입력하고 있는 키워드

  // data
  products: Array<RelUgcProductVO> = [];
  orders: Array<RelUgcProductVO> = [];
  orderLength = 0;

  // paging
  startNum = 0;
  limitNum = 3;

  // Infinite scroll data
  ajaxInited = false;
  busy = false;

  search(loadMore?: boolean) {
    this.busy = true;
    this.ajaxInited = false;

    if (!loadMore) {
      this.products = [];
    }

    const params = {
      keyword: this.inputKeyword,
      orderBy: this.inputKeyword ? null : "recommend", // 추천순/가격순
      pageStart: loadMore ? this.products.length : 0,
      isReview: true,
      ugcTypeCd: '047001'
    };

    axios.post("/products", params).then((r) => {
      this.products = loadMore ? this.products.concat(r.data as Array<RelUgcProductVO>) : r.data;
      this.ajaxInited = true;
      if (r.data.length) {
        this.busy = false;
      }
    });
  }

  // 비주문 상품 목록 더보기
  onLoadMore() {
    this.search(true);
  }

  // 주문 상품 목록
  selectOrderedProducts(): void {
    const params = {
      keyword: this.inputKeyword,
      startNum: this.startNum,
      limitNum: this.limitNum,
    };

    axios.post("/ugc/orders", params).then((r) => {
      this.orders = this.orders.concat(r.data as Array<RelUgcProductVO>);
      this.orderLength = r.data.length;
    });
  }

  // 주문상품목록 더보기
  moreOrderProduct(): void {
    this.selectOrderedProducts();
  }

  choiceProduct(product: RelUgcProductVO): void {
    this.$emit("update:product", product);
    this.$emit("update:opened", false);
  }

  // initialized events
  @Watch("opened")
  onOpened(): void {
    if (this.opened) {
      //구매상품리뷰 초기화
      this.startNum = 0;
      this.orders = [];

      this.search();
    }
  }

  created() {
    this.search();
  }
}
